var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"fw500 fz18 text-dark"},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }